import { useState, useEffect } from 'react';
import { STORAGE_KEYS } from '../constants/storage';

/**
 * Custom hook for managing sidebar collapsed state
 * 
 * Persists sidebar state to localStorage
 */
export const useSidebar = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    // Load sidebar state from localStorage on mount
    const saved = localStorage.getItem(STORAGE_KEYS.SIDEBAR_COLLAPSED);
    return saved === 'true';
  });

  // Save sidebar collapsed state to localStorage
  useEffect(() => {
    localStorage.setItem(STORAGE_KEYS.SIDEBAR_COLLAPSED, sidebarCollapsed.toString());
  }, [sidebarCollapsed]);

  const toggleSidebar = () => {
    setSidebarCollapsed(prev => !prev);
  };

  return {
    sidebarCollapsed,
    setSidebarCollapsed,
    toggleSidebar,
  };
};

